export default [
  {
    path: '/configuration/e-invoice',
    name: 'e-invoice-configuration',
    component: () =>
      import('@/views/modules/e-invoice-configuration'),
    // children: [
    //   {
    //     path: 'decimal-setting',
    //     name: 'e-invoice-configuration-decimal',
    //     component: () => 
    //       import('@/views/modules/e-invoice-configuration/decimal-setting'),
    //     meta: {
    //       requiresAuth: true,
    //     },
    //   },
    //   {
    //     path: 'detail',
    //     name: 'e-invoice-configuration-detail',
    //     redirect: '/detail/e-invoice',
    //     component: () =>
    //       import('@/views/modules/e-invoice-configuration/e-invoice-detail-setting'),
    //     children: [
    //       {
    //         path: 'e-invoice',
    //         name: 'e-invoice',
    //         component: () => 
    //           import('@/views/modules/e-invoice-configuration/e-invoice-detail-setting/e-invoice'),
    //         meta: {
    //           requiresAuth: true,
    //         },
    //       },
    //       {
    //         path: 'ticket',
    //         name: 'ticket',
    //         component: () =>
    //           import('@/views/modules/e-invoice-configuration/e-invoice-detail-setting/ticket'),
    //         meta: {
    //           requiresAuth: true,
    //         },
    //       }
    //     ],
    //     meta: {
    //       requiresAuth: true,
    //     },
    //   }
    // ],
    meta: {
      requiresAuth: true,
    },
  },
]